import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import {environment } from 'src/environments/environment';
import { PlatformLocation } from "@angular/common";
import { BehaviorSubject, of } from "rxjs";
import { handleError } from "../helper/utilities";
import { environment } from "src/environments/environment";
import { catchError } from "rxjs/operators";
import { DataService } from "src/app/data.service";
/**
 * Data Service keeps all the state variables and all api calls are made here.
 */
@Injectable({
  providedIn: "root",
})
export class PriceScenarioService {
  private dataForScenario: any;
  //to be removed
  private selectedChannel: string = "TT";
  path: any;
  currentScenario: any;
  currentChildScenario: any;
  loggedIn = false;
  hideNav = false;
  errorMsg: any;
  cookies: any = {};
  currentScreen: any;
  showLoader = new BehaviorSubject(false);
  private _channelPE = new BehaviorSubject<string>("TT");
  public readonly channelPE$ = this._channelPE.asObservable();
  constructor(
    private http: HttpClient,
    private platformLocation: PlatformLocation,
    private dataService: DataService,
  ) {}

  //obeservable function
  private _scenarioName = new BehaviorSubject<string>("");
  public readonly scenarioName$ = this._scenarioName.asObservable();
  setScenarioName(val: string) {
    this._scenarioName.next(val);
  }
  changeChannelForPE(val: string) {
    console.log("channelPe", val);
    this._channelPE.next(val);
  }
  private _summaryTableData = new BehaviorSubject<any>([]);
  public readonly summaryTableData$ = this._summaryTableData.asObservable();
  setSummaryTableData(val: any) {
    this._summaryTableData.next(val);
  }
  private _percentTableData = new BehaviorSubject<any>([]);
  public readonly percentTableData$ = this._percentTableData.asObservable();
  setPercentTableData(val: any) {
    console.log("setPercentTableData", val);
    this._percentTableData.next(val);
  }
  //old functions
  getPath() {
    return this.path;
  }
  setErrorMsg(msg: any) {
    this.errorMsg = msg;
  }
  getErrorMsg() {
    return this.errorMsg;
  }
  setSelectedChannel(channel: any) {
    localStorage.setItem(this.selectedChannel, channel);
  }
  getSelectedChannel() {
    return localStorage.getItem(this.selectedChannel) || "TT";
  }
  sendScenarioToBuilder(data: any) {
    this.dataForScenario = data;
    localStorage.setItem(
      "dataForScenario",
      JSON.stringify(this.dataForScenario),
    );
  }
  setCurrentScenario(name: any) {
    // this.currentScenario = name;
    localStorage.setItem("currentScenario", name);
  }
  getCurrentScenario() {
    // return this.currentScenario;
    return localStorage.getItem("currentScenario");
  }
  setCurrentChildScenario(child: any) {
    // this.currentChildScenario = child;
    localStorage.setItem("currentChildScenario", child);
  }
  getCurrentChildScenario() {
    // return this.currentChildScenario;
    return localStorage.getItem("currentChildScenario");
  }
  setPath(path: any) {
    this.path = path;
  }
  setLogin() {
    this.loggedIn = true;
  }
  getLogin() {
    return this.loggedIn;
  }
  getCurrentScreen() {
    return this.currentScreen;
  }
  setCurrentScreen(screen: any) {
    this.currentScreen = screen;
  }
  getCookie(name: string) {
    if (this.cookies[name]) {
      return this.cookies[name];
    } else {
      const cookie = this.findCookie(name);
      this.cookies[name] = cookie;
      return cookie;
    }
  }
  findCookie(name: string) {
    const ca: Array<string> = decodeURIComponent(document.cookie).split(";");
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;
    for (let i = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, "");
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return "";
  }

  setCurrentChildScenarioVersion(version: any) {
    localStorage.setItem("currentScenarioVersion", version);
  }
  getCurrentChildScenarioVersion() {
    return localStorage.getItem("currentScenarioVersion");
  }
}
